module.exports = __webpack_public_path__ + "static/img/doom-yoga-login-image2.ccfa17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/doom-yoga-login-image2.png
// module id = ZHPw
// module chunks = 0